
import {
  Obra
} from '../index';


export class ObraDocumentacao {
  "ObraId";
  "situacao";
  "dataDaConclusao";
  "tempoAteOVencimentoDoSLADoASP";
  "tempoDeAtendimentoDoASP";
  "situacaoDoEnvio";
  "dataDeCriacao";
  "todosDocumentosObrigatoriosForamIncluidos";
  "todosDocumentosForamEntregues";
  "aSPResponsavelVendor";
  "aSPResponsavelNome";
  "aptoParaPDI";
  "dataDeLiberacaoParaPDI";
  "dataDeInicioValidacaoEricsson";
  "dataDaEntregaDosDocumentos";
  "dataDaUltimaValidacao";
  "tempoDeAtendimentoDaEricssonDias";
  "situacaoDaValidacao";
  "prioridadeDaDocumentacao";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraDocumentacao`.
   */
  static getModelName() {
    return "ObraDocumentacao";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraDocumentacao for dynamic purposes.
  **/
  static factory(data) {
    return new ObraDocumentacao(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraDocumentacao',
      plural: 'ObraDocumentacaos',
      path: 'ObraDocumentacaos',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "situacao": {
          name: 'situacao',
          type: 'string'
        },
        "dataDaConclusao": {
          name: 'dataDaConclusao',
          type: 'Date'
        },
        "tempoAteOVencimentoDoSLADoASP": {
          name: 'tempoAteOVencimentoDoSLADoASP',
          type: 'number'
        },
        "tempoDeAtendimentoDoASP": {
          name: 'tempoDeAtendimentoDoASP',
          type: 'number'
        },
        "situacaoDoEnvio": {
          name: 'situacaoDoEnvio',
          type: 'string'
        },
        "dataDeCriacao": {
          name: 'dataDeCriacao',
          type: 'Date'
        },
        "todosDocumentosObrigatoriosForamIncluidos": {
          name: 'todosDocumentosObrigatoriosForamIncluidos',
          type: 'boolean'
        },
        "todosDocumentosForamEntregues": {
          name: 'todosDocumentosForamEntregues',
          type: 'boolean'
        },
        "aSPResponsavelVendor": {
          name: 'aSPResponsavelVendor',
          type: 'string'
        },
        "aSPResponsavelNome": {
          name: 'aSPResponsavelNome',
          type: 'string'
        },
        "aptoParaPDI": {
          name: 'aptoParaPDI',
          type: 'string'
        },
        "dataDeLiberacaoParaPDI": {
          name: 'dataDeLiberacaoParaPDI',
          type: 'Date'
        },
        "dataDeInicioValidacaoEricsson": {
          name: 'dataDeInicioValidacaoEricsson',
          type: 'Date'
        },
        "dataDaEntregaDosDocumentos": {
          name: 'dataDaEntregaDosDocumentos',
          type: 'Date'
        },
        "dataDaUltimaValidacao": {
          name: 'dataDaUltimaValidacao',
          type: 'Date'
        },
        "tempoDeAtendimentoDaEricssonDias": {
          name: 'tempoDeAtendimentoDaEricssonDias',
          type: 'number'
        },
        "situacaoDaValidacao": {
          name: 'situacaoDaValidacao',
          type: 'string'
        },
        "prioridadeDaDocumentacao": {
          name: 'prioridadeDaDocumentacao',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraDocumentacao.js